import { _ as b } from "./index.es386.js";
import { _ as T } from "./index.es387.js";
import { _ as j } from "./index.es388.js";
import { _ as M } from "./index.es290.js";
import { _ as v } from "./index.es389.js";
import { _ as C } from "./index.es390.js";
import { _ as k } from "./index.es391.js";
var a = b, t = T, o = j, i = M, s = v, S = C, e = k, g = "[object Map]", V = "[object Object]", _ = "[object Promise]", f = "[object Set]", w = "[object WeakMap]", u = "[object DataView]", d = e(a), D = e(t), P = e(o), W = e(i), G = e(s), r = S;
(a && r(new a(new ArrayBuffer(1))) != u || t && r(new t()) != g || o && r(o.resolve()) != _ || i && r(new i()) != f || s && r(new s()) != w) && (r = function(n) {
  var m = S(n), c = m == V ? n.constructor : void 0, p = c ? e(c) : "";
  if (p)
    switch (p) {
      case d:
        return u;
      case D:
        return g;
      case P:
        return _;
      case W:
        return f;
      case G:
        return w;
    }
  return m;
});
var $ = r;
export {
  $ as _
};
//# sourceMappingURL=index.es261.js.map
